type LogoVariant = "compact" | "full";

interface LogoProps {
  /** "compact" = image + wordmark (nav). "full" = image + wordmark + tagline (auth, splash). */
  variant?: LogoVariant;
  /** Optional override for the logo image height in px. Defaults per variant. */
  size?: number;
  className?: string;
}

const IMAGE_HEIGHT: Record<LogoVariant, number> = {
  compact: 28,
  full: 44,
};

const WORDMARK_SIZE: Record<LogoVariant, number> = {
  compact: 17,
  full: 24,
};

/**
 * CiaoTutor brand lockup: tricolore soundwave + two-tone "CiaoTutor" wordmark,
 * with an optional tagline. All colors come from theme tokens so it adapts to
 * dark/light automatically. Used compact in the nav, full on auth/splash.
 */
export default function Logo({ variant = "compact", size, className }: LogoProps) {
  const imgHeight = size ?? IMAGE_HEIGHT[variant];
  const wordmarkSize = WORDMARK_SIZE[variant];

  return (
    <span className={`inline-flex items-center gap-2.5 ${className ?? ""}`}>
      <span className="logo-mark inline-flex flex-shrink-0">
        <img
          src="/logo.png"
          alt="CiaoTutor"
          height={imgHeight}
          style={{ height: imgHeight, width: "auto" }}
          className="block"
        />
      </span>
      <span className="inline-flex flex-col justify-center leading-none">
        <span
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 800,
            fontSize: wordmarkSize,
            letterSpacing: "0.1em",
            lineHeight: 1,
          }}
        >
          <span style={{ color: "var(--ink)" }}>ciao</span>
          <span style={{ color: "var(--success)" }}>tutor</span>
        </span>
        {variant === "full" && (
          <span
            style={{
              fontFamily: "var(--font-sans)",
              fontWeight: 400,
              fontSize: 13,
              letterSpacing: "0.03em",
              color: "var(--text-tertiary)",
              marginTop: "0.15rem",
            }}
          >
            Speak Italian, naturally.
          </span>
        )}
      </span>
    </span>
  );
}
